import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ReadService } from './read.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import FileSaver from 'file-saver';
import { MessageService } from 'primeng';
import { Message } from '../classes/Message';
import moment from 'moment';

@Injectable({ providedIn: 'root' })
export class OrganisationInvoiceReportService extends ReadService<any, any> {
  url = '/api/organisation-invoice-report';
  entityTitle = 'Organisation Invoice Report';

  constructor(
    http: HttpClient,
    handlersFactory: HttpResponsesHandlersFactory,
    private messageService: MessageService,
  ) {
    super(http, handlersFactory);
  }

  public getCustomerReportSettings(organisationId: number): Promise<any> {
    return this.http
      .get(`${this.url}/settings/${organisationId}`, { headers: new HttpHeaders({}) })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public saveCustomerReportSettings(dto: any[]) {
    const url = `${this.url}/settings`;
    return this.handleRequest<any[]>(
      this.http.post<any[]>(url, dto),
      this.handlersFactory.getForCreate(this.entityTitle),
    );
  }

  public downloadCustomerReportToCSV(
    invoiceId: number,
    isDryRun: boolean,
    transactionIds?: number[],
  ) {
    if (!transactionIds) transactionIds = [];
    let filename = `Invoice_${invoiceId}_${moment().format('YYYYMMMMDo_h:mm')} + .csv`;
    let report = this.http.post(
      `${this.url}/downloadCustomerReportToCSV/${invoiceId}/${isDryRun}`,
      transactionIds,
      { responseType: 'blob' },
    );
    report.subscribe(
      (x) => this.handleDownloadFile(x, filename),
      (error) => {
        this.messageService.add(Message.Error('Failed to download the csv.'));
      },
      () => {},
    );
    return report.toPromise();
  }

  public handleDownloadFile(blob, filename) {
    FileSaver.saveAs(blob, filename);
    this.messageService.add(Message.Success('Downloaded successful. Check your download folder.'));
  }
}
